import React, { useState, useEffect, Component } from 'react';
import { connect } from 'react-redux'

import '../../assets/css/tor-template-list.css'
import { DatePicker,Select,InputDecimal,DropDownMuti } from '../../components/core';
import $ from 'jquery'
import { SecureGateRoute, BreadCrumb, DetailBotLogModal } from '../../components';
import { searchReportAction } from '../../redux/actions/ReportAction'
import ReportTablePage from '../../components/Report/ReportTablePage';
import {AppSettings } from '../../configs'
import { Storage } from "../../configs";
import {
    data_status,
} from '../../configs/datas'
import moment from 'moment'
import {msg} from '../../components/Notifications/MsgBox';
import ReactTooltip from 'react-tooltip'
import { AdjustmentService } from '../../services';
import { useHistory } from "react-router";
import NotiAdjustmentTable from './Table/NotiAdjustmentTable';


const serachCondition = {
    PO_CONTRACT_NO: '',
    HEADER_TEXT: '',
    COMPANY: '',
    CREATE_BY: '',
    CREATE_DATE_FROM: '',
    CREATE_DATE_TO: '',
    MUTI_STATUS: '',
    ADJUSTMENT_TYPE: 'NotiAdjustment'
}


export default () => {
    const [serachConditionModel,setsearchData] = useState({
        ADJUSTMENT_TYPE: 'NotiAdjustment'
    });
    const [resultSearch,setResultSearch] = useState([]);
    const history = useHistory();

    const statusOptions = () => {
        return Promise.resolve([
            {
                value: "DRAFT",
                label: "Draft"
            },
            {
                value: "WAITFAPP",
                label: "Waitting for Approve"
            },
            {
                value: "COMPLETE",
                label: "Complete"
            },
            {
                value: "REJECT",
                label: "Reject"
            },
        ]);
    }

    useEffect(() => {
        setsearchData({...serachCondition});
        searchReportAction(serachConditionModel);

      }, [])
      
    function searchReportAction(serachConditionModel) {

        try {

            AdjustmentService.searchReportAction(serachConditionModel).then((response) => {
                console.log("searchReportAction", response);
                console.log(response);
               
                 var obj = response;
                if (obj.success) {
                    setResultSearch(obj.data)
                }else{
                    setResultSearch([])
                    //showMessage("error", obj.message, true);
                }
            })
        } catch (e) {
            console.log(e);
            //showMessage("error", "System error.", true);
        }
    }

    const handleChangeSerachConditionModel = (event) => {

        const target = event.target
        let value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')
                    }
                }
            }
        }

        serachConditionModel[name] = value;
        setsearchData({ ...serachConditionModel});
        console.log("handleChangeSerachConditionModel")
        console.log(serachConditionModel);

      };

      const handleSearch = (event) => {
        searchReportAction(serachConditionModel);
      };

      const handleClear = (event) => {
        setsearchData({...serachCondition});
        searchReportAction({...serachCondition});
      };
      
      const handleAdd = (event) => {
        history.push(`/NotiAdjustmentDetail/${0}`);
      };

      const handleDropdownMutiChange = (objs)=>{
        if(objs)
        {
            if(objs.length > 0)
            {
              setsearchData((previous => ({...previous,'MUTI_STATUS':objs})))
            }
        }

        console.log('objs',objs)
    }

        return (
            <div className="tor tor-template-list">
                <SecureGateRoute/>
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            {name:'RRS Home',url:AppSettings.defaultUrl},
                            {name:'หนังสือแจ้งค่าปรับ',url:''}
                        ]}></BreadCrumb>

                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">หนังสือแจ้งค่าปรับ</h1>
                            </div>
                        </div>

                        <div className="sp-page-result-container">
                            
                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">PO/Contract No.</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            id="PO_CONTRACT_NO"
                                            name="PO_CONTRACT_NO"
                                            className="form-control"
                                            placeholder="ข้อมูล Purchase / Contract Number"
                                            value={serachConditionModel.PO_CONTRACT_NO}
                                            //defaultValue={serachConditionModel.PO_CONTRACT_NO}
                                            onChange={handleChangeSerachConditionModel}
                                            maxLength={10}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                            <div className="rrs-detail-data">
                                <label htmlFor="gr_post_date" className="rrs-label mb-0">ชื่องาน</label>
                            </div>
                            <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            id="HEADER_TEXT"
                                            name="HEADER_TEXT"
                                            className="form-control"
                                            placeholder="ชื่องาน"
                                            value={serachConditionModel.HEADER_TEXT}
                                            //defaultValue={serachConditionModel.HEADER_TEXT}
                                            onChange={handleChangeSerachConditionModel}
                                            maxLength={250}
                                        />
                                    </div>
                                </div>

                        </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">Company</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            id="COMPANY"
                                            name="COMPANY"
                                            className="form-control"
                                            placeholder="ข้อมูล Company"
                                            value={serachConditionModel.COMPANY}
                                            //defaultValue={serachConditionModel.COMPANY}
                                            onChange={handleChangeSerachConditionModel}
                                            maxLength={150}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                            <div className="rrs-detail-data">
                                <label htmlFor="gr_post_date" className="rrs-label mb-0">Create By</label>
                            </div>
                            <div className="rrs-detail-data">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        id="CREATE_BY"
                                        name="CREATE_BY"
                                        className="form-control"
                                        //defaultValue={serachConditionModel.CREATE_BY}
                                        value={serachConditionModel.CREATE_BY}
                                        onChange={handleChangeSerachConditionModel}
                                        maxLength={100}
                                    />
                                </div>
                            </div>

                        </div>
                        </div>

                        <div className="row">
                        <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">Status</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                      
                                        <DropDownMuti
                                        loadOptions={statusOptions}
                                        id="MUTI_STATUS"
                                        value={serachConditionModel.MUTI_STATUS}
                                        className="form-control"
                                        placeholder=""
                                        onChange={handleDropdownMutiChange}
                                        // onChange={this.handleChange('runningNoSelectedOptions')}
                                        // value={this.state.runningNoSelectedOptions}
                                        >
                                        </DropDownMuti>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">Create Date</label>
                                </div>
                                <div className="row">
                                    <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>From: </span></div>
                                    <div className="col-md-5">
                                        <DatePicker
                                            name="CREATE_DATE_FROM"
                                            id="CREATE_DATE_FROM"
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            value={serachConditionModel.CREATE_DATE_FROM}
                                            onChange={handleChangeSerachConditionModel}
                                            onBlur={handleChangeSerachConditionModel}
                                            readOnly={true}
                                            //ref={this.create_date_from_ref}
                                        />
                                    </div>
                                    <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>To: </span></div>
                                    <div className="col-md-5">
                                        <DatePicker
                                            name="CREATE_DATE_TO"
                                            id="CREATE_DATE_TO"
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            value={serachConditionModel.CREATE_DATE_TO}
                                            onChange={handleChangeSerachConditionModel}
                                            onBlur={handleChangeSerachConditionModel}
                                            readOnly={true}
                                            //ref={this.create_date_to_ref}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br></br>
                        <div className="rrs-detail2">
                            <div className="rrs-form-group-search">
                                <div className="row justify-content-center mx-0">
                                    <div className="col-md-12"/>
                                        <div className="col-md-4" style={{ textAlign: "left", paddingTop:20 }}>
                                            {/* <a onClick={handleAdd} style={{ cursor: 'pointer', marginLeft: 10, marginRight: 10 }}>
                                                <i className="icon btn-plus" />
                                            </a> */}
                                        </div>
                                        <div className="col-md-4">
                                            <a onClick={handleSearch} style={{ cursor: 'pointer' }}>
                                                <i className="icon btn-order-search"  />
                                            </a>
                                            <a onClick={handleClear} style={{ cursor: 'pointer',marginLeft:10,marginRight:10 }}> 
                                                <i className="icon btn-order-clear"  />
                                            </a>
                                        </div>
                                        <div className="col-md-4" style={{textAlign:"right"}}>
                                            
                                        </div>
                                </div>
                            </div>
                        </div>

                        <br></br>
                            <div className="rrs-detail2">
                                <div className="sp-table-container">
                                    <div className="row no-gutters sp-table-content">
                                        <NotiAdjustmentTable
                                            dataTable_Adjustment={resultSearch}
                                            length={0}
                                        ></NotiAdjustmentTable>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <DetailBotLogModal />
                    </div>
                </div>
            </div >
        )

}